module.exports = __webpack_public_path__ + "b2e1b728d2cb08e2e354a1788bf2bf67.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon-filter.svg
// module id = DMyS
// module chunks = 5